import React, { useState, useEffect } from "react";
import "./WhoWeAre.css";
import AOS from "aos";
import "aos/dist/aos.css";

const WhoWeAre = () => {

  /* ⭐ Backend Base URL */
  const BASE_URL = "https://news-1-wyad.onrender.com";

  const [newsData, setNewsData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  /* ---------------- AOS INIT ---------------- */
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 120,
    });
  }, []);

  /* ---------------- FETCH NEWS ---------------- */
  useEffect(() => {

    const fetchNews = async () => {
      try {

        const response = await fetch(
          `${BASE_URL}/api/news`
        );

        if (!response.ok) throw new Error("Network error");

        const data = await response.json();

        const mappedData = data.map((item) => ({
          ...item,
          img: item.photo ? BASE_URL + item.photo : null,
          video: item.video ? BASE_URL + item.video : null,
        }));

        setNewsData(mappedData);

      } catch (error) {
        console.error(error);
        setNewsData([]);
      }
    };

    fetchNews();

  }, []);

  /* ---------------- MODAL HANDLERS ---------------- */

  const handleOpen = (item) => {
    setSelectedNews(item);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedNews(null);
  };

  return (
    <div className="who-container">

      {/* LEFT SECTION */}
      <div className="who-left" data-aos="fade-right">

        <h2 className="section-title1" data-aos="fade-up">
          Who We Are
        </h2>

       <div className="title-underline" data-aos="fade-left"></div>

        <img
          src="/home3.png"
          alt="Who we are"
          className="who-image"
          data-aos="zoom-in"
        />

       <p className="who-text" data-aos="fade-up" data-aos-delay="100">
          At our Old Age Home, we believe that every senior is a treasure of
          experience, wisdom, and love. No elder should feel lonely, forgotten,
          or unsupported. We provide a warm and peaceful environment where
          seniors can live with dignity, comfort, and emotional security.
        </p>

        <p className="who-text" data-aos="fade-up" data-aos-delay="200">
          Each elderly person has unique needs—physical, emotional, and social.
          Our team offers personalized attention, daily assistance, nutritious
          meals, medical care, and meaningful activities.
        </p>

        <button
          className="read-btn"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <a href="/about">Read More</a>
        </button>

      </div>

      {/* RIGHT SECTION */}
      <div className="who-right" data-aos="fade-left">

        <h2 className="section-title1" data-aos="fade-up">
          Activities & Programs
        </h2>
        <div className="title-underline" data-aos="fade-left"></div>

        <div className="news-list">

          {newsData.length > 0 ? (

            newsData.map((item, i) => (

              <div
                className="news-card"
                key={item._id || i}
                data-aos="fade-up"
                data-aos-delay={i * 120}
              >

                {item.img && (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="news-img"
                    loading="lazy"
                    onClick={() => handleOpen(item)}
                    onError={(e) => {
                      e.target.src = "/no-image.png";
                    }}
                  />
                )}

                <div>
                  <h4 className="news-title">{item.title}</h4>
                  <p className="news-date">{item.date}</p>
                </div>

              </div>
            ))

          ) : (
            <p data-aos="fade-up">Loading news...</p>
          )}

        </div>
      </div>

      {/* MODAL */}
      {openModal && selectedNews && (
        <div className="modal-overlay" onClick={handleClose}>

          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <span className="modal-close" onClick={handleClose}>
              ×
            </span>

            <h3 className="modal-title">
              {selectedNews.title}
            </h3>

            {selectedNews.video ? (
              <video className="modal-media" controls autoPlay>
                <source src={selectedNews.video} type="video/mp4" />
              </video>
            ) : (
              selectedNews.img && (
                <img
                  src={selectedNews.img}
                  className="modal-media"
                  alt="preview"
                />
              )
            )}

            <p className="modal-date">
              {selectedNews.date}
            </p>

          </div>

        </div>
      )}

    </div>
  );
};

export default WhoWeAre;